import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useUpdateWorkpapers } from '../../queries/use-update-workpapers';

type ChangeWorkpapersVisibilityConfirmProps = {
    workpaperIds: string[];
    onClose: () => void;
    action: 'PUBLIC' | 'PRIVATE';
};

function ChangeWorkpapersVisibilityConfirm({ workpaperIds, onClose, action }: ChangeWorkpapersVisibilityConfirmProps): JSX.Element {
    const title = action === 'PRIVATE' ? `Make ${workpaperIds.length} workpapers private` : `Make ${workpaperIds.length} workpapers public`;
    const description =
        action === 'PRIVATE'
            ? `Do you want to make ${workpaperIds.length} workpapers private? Only assignees will have access to these workpapers.`
            : `Do you want to make ${workpaperIds.length} workpapers public? Anyone will have access to these workpapers.`;

    const updateWorkpapersQuery = useUpdateWorkpapers();
    function update(): void {
        updateWorkpapersQuery.mutate(
            workpaperIds.map((id) => ({ id, fields: { private: action === 'PRIVATE' } })),
            {
                onSuccess: () => {
                    toastNotification('success', `Updated ${workpaperIds.length} workpapers!`);
                },
                onError: (err) => {
                    const results = err.response?.data?.results ?? [];
                    const errors = results.filter((r: { statusCode: number }) => r.statusCode >= 400);
                    const success = results.filter((r: { statusCode: number }) => r.statusCode < 400);

                    if (success.length > 0) {
                        toastNotification('success', `Update ${success.length} workpapers!`);
                    }
                    toastNotification('error', `Unable to update ${errors.length} workpapers!`);
                },
                onSettled: () => onClose(),
            }
        );
    }

    return (
        <Dialog
            title={title}
            description={description}
            isOpen={true}
            primaryAction={action === 'PRIVATE' ? 'Make private' : 'Make public'}
            secondaryAction="Cancel"
            type="info"
            onClose={onClose}
            onPrimaryActionClick={update}
            onSecondaryActionClick={onClose}
            isLoading={updateWorkpapersQuery.isLoading}
        />
    );
}
export default ChangeWorkpapersVisibilityConfirm;
